import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

export interface IPersonalDataResponse {
    firstName?: string
    lastName?: string
    dateOfBirth?: string
    addresses?: [{
        country?: string
        city?: string
        street?: string
        housenumber?: string
        zipCode?: string
        primary?: boolean
    }],
    phoneNumbers?: [{
        number?: string
        primary?: boolean
    }]
}

export class WeProfileFacade {
    private etagVersions = new Map<string, string>();

    private readonly resourceHostId: string;

    public constructor(private readonly authService: IAuthServiceV2, stage: string) {
        this.resourceHostId = `myvw-customer-profile-${stage}`;
    }

    public async get<T = any>(weProfileFolder: string): Promise<T> {
        const url = `v2/customers/__userId__/${weProfileFolder}`;
        const response = await this.authService.get(this.resourceHostId, url);
        const eTag = response.headers.get('etag');
        if (eTag) {
            this.etagVersions.set(weProfileFolder, eTag);
        }

        if (!response.ok) {
            if (response.status === 404) {
                this.etagVersions.set(weProfileFolder, '0');
            }
            throw new Error(`Request failed with status code ${response.status}`);
        }


        return await response.json();
    }

    public async patch(weProfileFolder: string, jsonPatch: any): Promise<void> {
        const url = `v2/customers/__userId__/${weProfileFolder}`;
        const etag = this.etagVersions.get(weProfileFolder);
        if (etag) {
            const response = await this.authService.patch(this.resourceHostId, url, JSON.stringify(jsonPatch),
                {
                    'Content-Type': 'application/json-patch+json',
                    'If-Match': etag,
                });
            if (!response.ok) {
                throw new Error(`Request failed with status code ${response.status}`);
            }
            const eTag = response.headers.get('etag');
            if (eTag) {
                this.etagVersions.set(weProfileFolder, eTag);
            }
        } else {
            throw Error('No etag version available');
        }
    }
}
